import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CalculationPDF from "../../components/CalculationPDF/CalculationPDF";
import { formatCurrency } from '../../helpers/formatting';
import { ESTIMATE_REQUIRED } from '../../modules/Screen/reducer';

const propTypes = {
  activeCategories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      feeType: PropTypes.string,
      feeValue: PropTypes.number.isRequired,
      feeQuantity: PropTypes.number,
    })
  ),
  activeStages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
      sort: PropTypes.number,
      subStages: PropTypes.array,
    })
  ),
  scheduleName: PropTypes.string,
  scheduleGroup: PropTypes.string,
  calculation: PropTypes.number.isRequired,
  scroll: PropTypes.func.isRequired,
}

export default function CalculationOutput(props: InferProps<typeof propTypes>): JSX.Element {
  const { activeCategories, activeStages, scheduleName, scheduleGroup, calculation, scroll } = props;

  React.useEffect(() => {
    scroll();
  }, []);

  return (
    <>
      <h3 className="calculation-header">{scheduleGroup} Prosecution</h3>

      {activeStages?.map((stage, index) => {
        return (
          <>
            <Row key={`calculation_row_${stage.name}`} className='calculation-stage'>
              <Col md={{ span: 5, offset: 0 }}>
                <h3>{stage.name}</h3>
              </Col>
            </Row>
            {stage.subStages?.map((subStage, index) => {
              return (
                <>
                  <Row key={`calculation_row_${subStage.name}`} className='calculation-subStage' >
                    <Col md={{ span: 4, offset: 1 }}>
                      <h4>{subStage.name}</h4>
                    </Col>
                  </Row>
                  {subStage.categories?.map((category, index) => {
                    let active = false;
                    if (activeCategories?.includes(category)) {
                      active = true;
                    }
                    return (
                      <Row key={`calculation_row_${category.name}`} className={`calculation-category ${active ? 'calculation-category--active' : ''}`}>
                        <Col md={{ span: 4, offset: 2 }}>
                          <p>{`${category.name}:`}</p>
                        </Col>
                        <Col md={{ span: 3, offset: 3 }}>
                          {active
                            ? (category.feeType === ESTIMATE_REQUIRED
                                ? <p>Estimate required</p>
                                : (category.feeQuantity
                                  ? <p>{`$${formatCurrency(category.feeValue * category.feeQuantity)} ($${formatCurrency(category.feeValue, false)} x ${category.feeQuantity})`}</p>
                                  : <p>{`$${formatCurrency(category.feeValue)}`}</p>)
                              )
                            : <p> $0.00 </p>}
                        </Col>
                      </Row>
                    )
                  })}
                </>
              )
            })}
          </>
        )
      })}
      <Row key={`calculation_total`} className='calculation-total' >
        <Col md={{ span: 6, offset: 6 }}>
          <p>Total excluding GST: ${formatCurrency(calculation)}</p>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 4, offset: 4 }} className='export-btn--container'>
          <CalculationPDF
            activeCategories={activeCategories}
            activeStages={activeStages}
            scheduleName={scheduleName}
            scheduleGroup={scheduleGroup}
            calculation={calculation} />
        </Col>
      </Row>
    </>
  );
}
